import type { ComponentPropsWithRef } from 'react'
import React, { forwardRef } from 'react'
import { KibChevronDownIcon } from '@chewy/kib-icons-react'
import classNames from 'classnames'

import styles from './RhapInlineSelect.module.scss'

export interface RhapInlineSelectProps
  extends Omit<ComponentPropsWithRef<'select'>, 'className'> {
  className?: string
  hiddenLabel?: boolean
  label: string
}

const RhapInlineSelect = forwardRef<HTMLSelectElement, RhapInlineSelectProps>(
  (
    { className, label, hiddenLabel = false, disabled, children, ...props },
    ref,
  ) => (
      <div className={classNames(styles.container, className)}>
        {!hiddenLabel && (
          <label className={styles.label} htmlFor={props.id}>
            {label}
          </label>
        )}
        <div className={styles.selectWrapper}>
          <select
            {...props}
            aria-label={hiddenLabel ? label : undefined}
            className={classNames(styles.select, {
              [styles.disabled]: disabled,
            })}
            disabled={disabled}
            ref={ref}
          >
            {children}
          </select>
          <div className={styles.iconContainer}>
            <KibChevronDownIcon
              className={styles.icon}
              height={16}
              width={16}
            />
          </div>
        </div>
      </div>
    ),
)

RhapInlineSelect.displayName = 'RhapInlineSelect'

export default RhapInlineSelect
